import { BaseClass } from 'app/shared/entidade-base';
import { EnumStatusCadastroBase } from 'app/shared/enum.service';
import { VinculosLimiteDespesaViagemDTO } from './vinculos-limite-despesa-viagem.model';

export class RegrasLimiteDespesaViagemDTO extends BaseClass {
    
    statusCadastro:	EnumStatusCadastroBase;
    codigoRegra: string;
    valorRegra: number;
    vinculosLimiteDespesaViagens: VinculosLimiteDespesaViagemDTO[];
    calcularReembolsoAuto: boolean;
    limiteDiario: boolean;

    constructor(regrasLimiteDespesaViagem?){

        regrasLimiteDespesaViagem = regrasLimiteDespesaViagem || {};
        super(regrasLimiteDespesaViagem);
        
        this.statusCadastro = regrasLimiteDespesaViagem.statusCadastro || 0;
        this.codigoRegra = regrasLimiteDespesaViagem.codigoRegra || '';
        this.valorRegra = regrasLimiteDespesaViagem.valorRegra || 0;
        this.vinculosLimiteDespesaViagens = regrasLimiteDespesaViagem.vinculosLimiteDespesaViagens || '';
        this.calcularReembolsoAuto = regrasLimiteDespesaViagem.calcularReembolsoAuto || false;
        this.limiteDiario = regrasLimiteDespesaViagem.limiteDiario || false;
    }
    
}